import { useContext } from 'react';
import { NotificationContext } from '../contexts/NotificationContext';

export default function useNotifications() {
  const { notifications, total } = useContext(NotificationContext);
  return { notifications, total };
}
